import { Message } from 'semantic-ui-react';
import React from 'react';

import { TitledCard } from 'Components/';

import StudentBulkImportLoading from '../../../vendorlinkintegration/components/LoadingComponents/StudentBulkImportLoading';

export const AeriesManualSync = (props) => {
  const { loading, isComplete } = props;

  return (
    <TitledCard title={'Manual Import'}>
      {!isComplete && !loading && (
        <Message info>
          <Message.Header>Manual Import</Message.Header>
          <Message.Content>
            This will start importing your students by mapping their data
            according to the mapping configuration you chose. It may take a few
            minutes.
          </Message.Content>
        </Message>
      )}
      {loading && !isComplete && <StudentBulkImportLoading />}
      {isComplete && !loading && (
        <Message info>
          <Message.Header>Manual Import has finished</Message.Header>
        </Message>
      )}
    </TitledCard>
  );
};



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesImportStep/AeriesManualSync.js